var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSandClock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 334 476",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.82 235.127C164.77 254.216 153.976 264.469 137.579 275.621C71.6194 331.435 62.3376 385.737 109.733 438.527L297.455 399.677C319.307 331.632 292.181 286.466 216.075 264.179C192.329 257.229 178.45 248.664 174.437 238.486L173.075 231.906C165.536 233.009 160.82 235.128 160.82 235.128L160.82 235.127Z",
    fill: "#EFEFE5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.0166 371.758C80.0806 392.067 88.1486 412.163 104.215 432.046C106.881 434.269 109.778 436.234 112.915 437.868C112.915 437.868 178.582 423.935 295.72 398.319C297.449 395.58 298.97 392.782 300.285 389.938C304.925 372.08 305.954 355.908 303.384 341.418C301.749 336.219 299.483 331.087 296.585 326.088C247.504 319.08 212.048 319.099 190.273 319.269C183.611 320.19 180.279 320.651 180.279 320.651C180.279 320.651 144.798 338.225 80.0181 371.759L80.0166 371.758Z",
    fill: "#EFEFE5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.0166 371.758C80.0806 392.067 88.1486 412.163 104.215 432.046C106.881 434.269 109.778 436.234 112.915 437.868C112.915 437.868 178.582 423.935 295.72 398.319C297.449 395.58 298.97 392.782 300.285 389.938C304.925 372.08 305.954 355.908 303.384 341.418C301.749 336.219 299.483 331.087 296.585 326.088C247.504 319.08 212.048 319.099 190.273 319.269C183.611 320.19 180.279 320.651 180.279 320.651C180.279 320.651 144.798 338.225 80.0181 371.759L80.0166 371.758Z",
    fill: "#FBD14B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.179 244.185C169.607 364.333 171.322 424.407 171.322 424.407L125.217 433.949C80.4929 373.397 83.4895 324.969 134.209 288.668C146.309 282.215 156.966 267.386 166.179 244.185Z",
    fill: "#E6E5D0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.53 326.525L171.324 424.408L125.219 433.95C106.547 408.669 96.1986 385.503 94.1627 364.451C129.707 346.117 154.916 333.366 168.53 326.526L168.53 326.525Z",
    fill: "#E8BF31"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M217.712 416.179C178.55 426.211 163.086 428.954 171.324 424.408C111.118 362.938 141.198 311.014 171.637 242.718C233.435 323.293 248.792 381.113 217.713 416.18L217.712 416.179Z",
    fill: "#F0F0E4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.347 425.77C169.637 425.43 170.295 424.975 171.324 424.408C143.439 395.937 134.929 369.514 136.846 342.563C165.229 328.105 180.279 320.651 180.279 320.651C180.279 320.651 183.611 320.19 190.273 319.269C198.244 319.206 208.053 319.165 219.689 319.479C238.191 360.595 237.84 392.474 218.628 415.111C199.801 419.195 183.329 422.755 169.348 425.768L169.347 425.769L169.347 425.77Z",
    fill: "#F8D351"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M278.318 403.636C239.854 410.681 220.621 414.205 220.621 414.205C240.611 377.787 236.441 339.079 208.112 298.079C192.506 277.879 180.348 259.426 171.635 242.719C232.844 293.217 304.206 289.076 275.861 402.773L278.318 403.636Z",
    fill: "#FFFFF6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M234.601 411.644L220.622 414.205C237.094 384.196 237.159 352.632 220.822 319.513C236.045 319.952 254.341 321.01 275.699 323.419C283.74 341.372 285.056 365.819 275.891 402.652C261.206 405.857 247.429 408.857 234.602 411.645L234.601 411.644Z",
    fill: "#FEE996"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.6 244.152C157.649 225.063 144.814 219.724 125.338 215.997C42.6429 190.948 12.57 144.791 35.1187 77.5251L222.84 38.6743C269.907 92.4549 262.936 144.677 201.927 195.342C182.891 211.147 173.552 224.517 173.907 235.452C174.815 239.839 176.253 241.995 176.253 241.995C171.376 243.308 166.28 243.583 161.6 244.152Z",
    fill: "#FBD14B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.793 232.18C119.252 120.54 96.9802 64.721 96.9802 64.721L50.8752 74.2628C33.859 147.592 55.8312 190.852 116.793 204.04C130.46 205.16 146.127 214.541 163.793 232.18Z",
    fill: "#E8BF31"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.33 56.2973C103.402 62.6335 88.1206 66.2534 97.4856 67.1565C66.6245 147.474 114.843 183.193 169.889 233.797C194.629 135.313 185.775 76.1463 143.33 56.296L143.33 56.2973Z",
    fill: "#F8D351"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M203.704 42.6348C165.602 51.436 146.551 55.8358 146.551 55.8358C179.354 81.328 190.891 118.512 181.162 167.388C174.857 192.123 171.021 213.886 169.656 232.679C205.793 162.033 272.936 137.51 201.791 44.402L203.704 42.6335L203.704 42.6348Z",
    fill: "#FEE996"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.821 238.818L160.797 240.877L194.935 394.853C188.727 404.594 174.279 415.234 180.749 419.024C209.047 412.271 222.639 410.355 222.639 410.355C228.503 408.169 216.994 402.106 206.268 393.325L174.82 238.819L174.821 238.818Z",
    fill: "#F8D351"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M228.782 26.8641L26.2931 68.7712C23.7992 69.2873 22.1956 71.7315 22.7124 74.2287L24.8566 84.5893C25.3734 87.0865 27.8155 88.6934 30.3093 88.1773L232.799 46.2703C235.292 45.7541 236.896 43.3099 236.379 40.8127L234.235 30.4521C233.718 27.9549 231.276 26.348 228.782 26.8641Z",
    fill: "#1B4052"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.245 42.9111L67.5444 60.2338L71.5604 79.6387L155.262 62.316L151.245 42.9111Z",
    fill: "#254B56"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M209.797 30.7934L149.184 43.3377L153.2 62.7426L213.813 50.1983L209.797 30.7934Z",
    fill: "#335F67"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M228.782 26.8641L208.169 31.1302C208.192 31.312 208.222 31.495 208.26 31.6778L212.164 50.5408L232.8 46.27C235.285 45.7557 236.895 43.3007 236.38 40.8125L234.236 30.4519C233.721 27.9636 231.268 26.3496 228.784 26.8638L228.782 26.8641Z",
    fill: "#234F5C"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M239.796 2.19508L5.98055 50.5853C2.68652 51.2671 0.561474 54.4589 1.23487 57.7127L3.92262 70.6995C4.59601 73.9533 7.81341 76.0395 11.1074 75.3577L244.922 26.9675C248.217 26.287 250.342 23.0939 249.668 19.8401L246.98 6.85329C246.307 3.59954 243.09 1.51334 239.796 2.19508Z",
    fill: "#2F5D6B"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.759 18.9663L64.7499 38.4225L69.877 63.1961L163.886 43.74L158.759 18.9663Z",
    fill: "#527E8B"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M222.671 5.73926L156.698 19.3929L161.825 44.1666L227.798 30.5129L222.671 5.73926Z",
    fill: "#77A5B5"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M239.876 2.17843L222.26 5.82428L227.387 30.598L245.003 26.9521C248.24 26.2823 250.339 23.0824 249.668 19.8414L246.981 6.85456C246.31 3.61232 243.113 1.50859 239.876 2.17843Z",
    fill: "#41707A"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M303.539 388.154L101.049 430.061C98.5557 430.577 96.952 433.022 97.4688 435.519L99.6131 445.879C100.13 448.377 102.572 449.983 105.066 449.467L307.555 407.56C310.049 407.044 311.652 404.6 311.136 402.103L308.991 391.742C308.475 389.245 306.032 387.638 303.539 388.154Z",
    fill: "#1B4052"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M230.019 423.606L146.317 440.929L142.301 421.524L226.003 404.201L230.019 423.606Z",
    fill: "#254B56"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M288.569 411.488L227.958 424.032L223.942 404.627L284.553 392.083L288.569 411.488Z",
    fill: "#335F67"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M307.556 407.559L286.943 411.825C286.892 411.649 286.847 411.469 286.809 411.286L282.905 392.423L303.541 388.152C306.025 387.638 308.479 389.252 308.994 391.74L311.138 402.101C311.653 404.589 310.042 407.044 307.557 407.559L307.556 407.559Z",
    fill: "#234F5C"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M322.328 401.058L88.513 449.448C85.219 450.13 83.0939 453.322 83.7673 456.575L86.4551 469.562C87.1285 472.816 90.3459 474.902 93.6399 474.22L327.455 425.83C330.749 425.148 332.874 421.957 332.201 418.703L329.513 405.716C328.839 402.462 325.622 400.376 322.328 401.058Z",
    fill: "#2F5D6B"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M246.42 442.601L152.41 462.057L147.284 437.285L241.293 417.829L246.42 442.601Z",
    fill: "#527E8B"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M310.33 429.374L244.359 443.028L239.232 418.255L305.203 404.602L310.33 429.374Z",
    fill: "#77A5B5"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M327.535 425.814L309.919 429.459L304.792 404.686L322.408 401.04C325.645 400.37 328.842 402.474 329.513 405.715L332.2 418.7C332.871 421.941 330.771 425.141 327.535 425.811L327.535 425.814Z",
    fill: "#41707A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSandClock);
export default __webpack_public_path__ + "static/media/sand-clock.604b331b9f3f083940677ea945065551.svg";
export { ForwardRef as ReactComponent };